import React from 'react'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'

/**
 * @param isBorderlessBottom
 * @param isBorderlessTop
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export default function ModalBody ({
  isBorderlessBottom,
  isBorderlessTop,
  children
}) {
  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: isBorderlessBottom
          ? '0.27em 0.27em 0 0'
          : isBorderlessTop
            ? '0 0 0.27em 0.27em'
            : '0.27em 0.27em 0.27em 0.27em',
        padding: `${STYLES_PADDING.MEDIUM} ${STYLES_PADDING.BIG}`
      }}
    >
      {children}
    </div>
  )
}
